import { render, staticRenderFns } from "./Gourmet.vue?vue&type=template&id=62716aa0&scoped=true&"
import script from "./Gourmet.vue?vue&type=script&lang=js&"
export * from "./Gourmet.vue?vue&type=script&lang=js&"
import style0 from "./Gourmet.vue?vue&type=style&index=0&id=62716aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62716aa0",
  null
  
)

export default component.exports